import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';

const img1 = `${process.env.PUBLIC_URL}/img/images/logo.png`;

const Topbar = ({ changeMobileSidebarVisibility, changeSidebarVisibility,hideLogout }) => (
  <div className="topbar">
    <div className="topbar__wrapper">
      <div className="topbar__left">
        <TopbarSidebarButton
          onClickMobile={changeMobileSidebarVisibility}
          onClickDesktop={changeSidebarVisibility}
        />
                     <div style={{padding:'5px 0 0 5px'}}><img className="" src={img1} alt="Logo" style={{width:'190px'}}   /></div> 
        {/* <span className='titleName'>book<i>wed</i>go</span> */}
      </div>
  {!hideLogout ?
      <div className="topbar__right">
        <TopbarProfile />
      </div> : ''}
    </div>
  </div>
);

Topbar.propTypes = {
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  changeSidebarVisibility: PropTypes.func.isRequired,
};

export default Topbar;
